import { Component, OnInit } from '@angular/core';

import { EnumsService, BreakpointService } from '@library/core/services';

import { ShipmentService } from '../shipment.service';
import { AttachmentService } from '@library/modules/attachment';
import { InfoService } from '@library/modules/info';
import { AppConfigService } from '@library/app.config';

@Component({
   selector: 'shipment-attachments',
   templateUrl: './attachments.component.html',
   styleUrls: ['./attachments.component.scss']
})
export class AttachmentsComponent implements OnInit {

   constructor(
      public shipment: ShipmentService,
      public enums: EnumsService,
      public breakpoints: BreakpointService,
      public attachmentService: AttachmentService,
      public info: InfoService,
      public appConfig: AppConfigService,
   ) { }

   ngOnInit() {
      const fileTypes = this.appConfig.getExtendedConfig( 'attachments' ).filter( f => f.id === 'filetype' )[0]?.enum || [];
      setTimeout( _ => this.info.tooltips = fileTypes.length ? [ 'Accepted file types:', ...fileTypes ] : [] );
      const lengths: any = {};
      const config = this.shipment?.configs?.attachments?.items ?? {};

      Object.keys( config ).filter( key => config[key]?.maxLength )
         .map( key => lengths[key] = config[key]?.maxLength );

      this.attachmentService.lengths = lengths;
   }
}
